// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// Data
import { pushOnClick } from 'src/utils/paths';
import { MENU_ROUTES, ROUTES_REFS } from './constants';
// Components
import ProfileMenuLink from './ProfileMenuLink';
// Styles
import styles from './styles.scss';

const ProfileMenu = ({ currentRoute, push }) => {
  useEffect(() => {
    if (ROUTES_REFS[currentRoute].current) {
      ROUTES_REFS[currentRoute].current.scrollIntoView();
    }
  }, []);

  const clonedMenuRoutes = [...MENU_ROUTES];
  const clonedRoutesRefs = { ...ROUTES_REFS };

  const menuStyle = `site-v2 ${styles.menu}`;

  return (
    <div className={menuStyle}>
      {clonedMenuRoutes.map((routeInfo) => (
        <ProfileMenuLink
          key={routeInfo.label}
          currentRoute={currentRoute}
          routeInfo={routeInfo}
          routesRefs={clonedRoutesRefs}
          goToRoute={pushOnClick(push)}
        />
      ))}
    </div>
  );
};

ProfileMenu.propTypes = {
  currentRoute: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default ProfileMenu;

/*
  ProfileMenu:
    Used in the AccountNavigation Component to navigate between account features.

  Examples:
    <ProfileMenu currentRoute={this.props.url} />

  Properties:
    currentRoute:
      type: string
      description: Used to determine when to apply active styles to a tab.
*/
